<template>
  <span class="camel-chip" :class="`camel-chip--${camel}`" :title="camel">
    <svg viewBox="0 0 36 26" aria-hidden="true">
      <!-- a stylised racing camel, side-on, facing the direction of play:
           body, two humps, neck, head, four legs, a flick of tail -->
      <g>
        <rect x="6" y="11" width="19" height="8" rx="4" />
        <circle cx="13" cy="10" r="4.5" />
        <circle cx="20" cy="10" r="4.5" />
        <rect x="24" y="4" width="4" height="11" rx="2" />
        <rect x="24" y="3" width="9" height="4.5" rx="2.2" />
        <template v-if="!riding">
          <rect x="8" y="17" width="3" height="8" rx="1.4" />
          <rect x="13" y="17" width="3" height="8" rx="1.4" />
          <rect x="18" y="17" width="3" height="8" rx="1.4" />
          <rect x="22.5" y="17" width="3" height="8" rx="1.4" />
        </template>
        <rect x="3" y="11" width="4" height="3" rx="1.5" />
      </g>
    </svg>
  </span>
</template>

<script>
// One camel meeple. The five racing colours are the printed game's own
// (docs/board.jpg's tents); the SVG is drawn here rather than cropped from
// the mod because a stack of five has to stay readable at 14px tall, and
// the tile art doesn't survive that.
export default {
  name: 'CamelChip',
  props: {
    camel: { type: String, required: true },
    // A camel riding a stack tucks its legs - they otherwise dangle
    // through the body of the one below.
    riding: { type: Boolean, default: false },
  },
};
</script>
